var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "modalAjoutFournisseur" + _vm.produit.produitId,
            size: "x1",
            title: "Sélection d'un fournisseur",
            "ok-title": "Ajouter",
            "ok-disabled": !_vm.fournisseurId,
            "cancel-title": "Annuler",
            "no-close-on-backdrop": ""
          },
          on: {
            hide: function($event) {
              _vm.currentTabIndex = _vm.savTabIndex
            },
            ok: function($event) {
              return _vm.ajouterFournisseur()
            }
          }
        },
        [
          _c("template", { slot: "default" }, [
            _c("div", { staticClass: "container-fluid" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("v-select", {
                      attrs: {
                        id: "selectFournisseur",
                        options: _vm.optionsFournisseurs,
                        label: "nom",
                        placeholder: "Fournisseur...",
                        reduce: function(f) {
                          return f.fournisseurId
                        },
                        "z-index": "100"
                      },
                      model: {
                        value: _vm.fournisseurId,
                        callback: function($$v) {
                          _vm.fournisseurId = $$v
                        },
                        expression: "fournisseurId"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ])
        ],
        2
      ),
      _c("div", { staticClass: "container-fluid container-fiches" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 col-lg-3 col-xl-3" }, [
            _c(
              "div",
              {
                class: _vm.selected
                  ? "card no-radius card-selected-outline"
                  : "card no-radius",
                attrs: { id: _vm.cardId }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "card-header no-radius",
                    staticStyle: { "padding-top": "3px" }
                  },
                  [
                    !_vm.surGreAGre
                      ? _c("span", [
                          _vm._v(
                            _vm._s(_vm.produit.produitId) +
                              " - " +
                              _vm._s(_vm.produit.designation)
                          )
                        ])
                      : _c("span", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.produit.designation,
                                expression: "produit.designation"
                              }
                            ],
                            staticClass: "saisieSurTitreBleu",
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "text",
                              placeholder: "Désignation",
                              required: "",
                              title: "Désignation de votre produit"
                            },
                            domProps: { value: _vm.produit.designation },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.produit,
                                  "designation",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "card-content",
                    attrs: { "aria-expanded": "true" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _c(
                          "div",
                          { staticClass: "row flex-center-space-between" },
                          [
                            _c(
                              "div",
                              { staticClass: "col-6 form-group" },
                              [
                                _c(
                                  "label",
                                  {
                                    attrs: {
                                      for: "grammage-" + _vm.produit.produitId
                                    }
                                  },
                                  [_vm._v("Grammage ")]
                                ),
                                _c("InputNumber", {
                                  staticStyle: { width: "60px" },
                                  attrs: {
                                    id: "grammage-" + _vm.produit.produitId,
                                    typeFiltre: "quantite"
                                  },
                                  model: {
                                    value: _vm.produit.grammage,
                                    callback: function($$v) {
                                      _vm.$set(_vm.produit, "grammage", $$v)
                                    },
                                    expression: "produit.grammage"
                                  }
                                }),
                                _vm._v(" g ")
                              ],
                              1
                            ),
                            _vm.surGreAGre
                              ? _c("div", { staticClass: "col-6 form-group" }, [
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        title: "Unité de cotation du produit",
                                        for: "uc-" + _vm.produit.produitId
                                      }
                                    },
                                    [_vm._v("Coté en")]
                                  ),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.trim",
                                        value: _vm.produit.uc,
                                        expression: "produit.uc",
                                        modifiers: { trim: true }
                                      }
                                    ],
                                    staticStyle: { width: "70%" },
                                    attrs: {
                                      list: "texteUC",
                                      type: "text",
                                      id: "uc-" + _vm.produit.produitId,
                                      title: "Unité de cotation du produit"
                                    },
                                    domProps: { value: _vm.produit.uc },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.produit,
                                          "uc",
                                          $event.target.value.trim()
                                        )
                                      },
                                      blur: function($event) {
                                        return _vm.$forceUpdate()
                                      }
                                    }
                                  }),
                                  _vm._m(0)
                                ])
                              : _c("div", { staticClass: "col-6" }, [
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        title: "Unité de cotation du produit"
                                      }
                                    },
                                    [_vm._v("UC :")]
                                  ),
                                  _vm._v(" " + _vm._s(_vm.produit.uc) + " ")
                                ])
                          ]
                        ),
                        _c(
                          "div",
                          {
                            style: [
                              _vm.ingredientExiste(_vm.produit)
                                ? ""
                                : { color: "#D30943" }
                            ]
                          },
                          [_vm._v("Ingrédient")]
                        ),
                        _vm.ingredientExiste(_vm.produit)
                          ? _c("div", [
                              _c(
                                "div",
                                { staticClass: "ingredient-label bleuAgap" },
                                [_vm._v(_vm._s(_vm.ingredientNom(_vm.produit)))]
                              )
                            ])
                          : _vm._e(),
                        _c("RechercheIngredients", {
                          style: [
                            _vm.ingredientExiste(_vm.produit)
                              ? ""
                              : { border: "1px solid #D30943" }
                          ],
                          attrs: {
                            liste: _vm.ingredients,
                            placeHolder: "Rechercher un ingrédient...",
                            cacherAuto: true
                          },
                          on: {
                            "selection-ingredient": function($event) {
                              return _vm.setItemIngredientId(
                                $event,
                                _vm.produit
                              )
                            }
                          }
                        }),
                        _c("div", { staticClass: "push-top-1rem" }, [
                          _vm._v("Unité de production par défaut")
                        ]),
                        _vm.surGreAGre
                          ? _c(
                              "div",
                              { staticClass: "ingredient-label bleuAgap" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.upIngredient(_vm.produit.ingredientId)
                                  )
                                )
                              ]
                            )
                          : _c(
                              "b-form-select",
                              {
                                staticClass: "selectpicker push-bottom-1rem",
                                attrs: { options: _vm.optionsUp },
                                model: {
                                  value: _vm.produit.ingredientUP,
                                  callback: function($$v) {
                                    _vm.$set(_vm.produit, "ingredientUP", $$v)
                                  },
                                  expression: "produit.ingredientUP"
                                }
                              },
                              [
                                _c("template", { slot: "first" }, [
                                  _c(
                                    "option",
                                    {
                                      attrs: { disabled: "" },
                                      domProps: { value: null || undefined }
                                    },
                                    [_vm._v("Sélectionnez une UP...")]
                                  )
                                ])
                              ],
                              2
                            ),
                        _c("div", { staticClass: "flex-space-between" }, [
                          _vm.surGreAGre
                            ? _c("div", { staticClass: "flex-start" }, [
                                _vm.produit.utilisateurId ==
                                _vm.utilisateurCourant.id
                                  ? _c(
                                      "div",
                                      {
                                        attrs: {
                                          title:
                                            "Accessible pour vous (et vos subordonnées)"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.changerStatutProduit(
                                              _vm.produit
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fas fa-user push-left-1rem",
                                          class: {
                                            "fa-spin ": _vm.produit.enCoursSauve
                                          },
                                          staticStyle: { "font-size": "24px" }
                                        })
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      {
                                        staticStyle: { "font-size": "24px" },
                                        attrs: {
                                          title: "Accessible à la cuisine",
                                          disabled: _vm.produit.enCoursSauve
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.changerStatutProduit(
                                              _vm.produit
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "far fa-building push-left-1rem",
                                          class: {
                                            "fa-spin ": _vm.produit.enCoursSauve
                                          }
                                        })
                                      ]
                                    )
                              ])
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "flex-end" },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: {
                                        content:
                                          "Enregistrer les modifications",
                                        placement: "top"
                                      },
                                      expression:
                                        "{ content: 'Enregistrer les modifications', placement: 'top' }"
                                    }
                                  ],
                                  staticClass: "btn bleuAgap push-right-1rem",
                                  style: _vm.produitEstModifie
                                    ? "border: 1px solid red !important"
                                    : "",
                                  attrs: {
                                    type: "submit",
                                    disabled: !_vm.produitEstModifie
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.sauveProduit(_vm.produit)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-save",
                                    class: {
                                      "fa-spin ": _vm.enregistrementEnCours
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: {
                                        content: "Supprimer le gré à gré",
                                        placement: "top"
                                      },
                                      expression:
                                        "{ content: 'Supprimer le gré à gré', placement: 'top' }"
                                    }
                                  ],
                                  staticClass: "btn btn-danger",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.supprimeProduit(_vm.produit)
                                    }
                                  }
                                },
                                [_vm._v(" × ")]
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  ]
                )
              ]
            ),
            _vm.index !== 0 && !_vm.surGreAGre
              ? _c(
                  "div",
                  {
                    staticClass: "text-center push-bottom-1rem",
                    staticStyle: { color: "#1babae" }
                  },
                  [
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.copyTarif(_vm.index)
                          }
                        }
                      },
                      [_vm._v("Recopier les données de la fiche précédente")]
                    )
                  ]
                )
              : _vm._e(),
            !_vm.surGreAGre
              ? _c(
                  "div",
                  { staticClass: "post-it" },
                  [
                    _c("b-form-textarea", {
                      staticStyle: { "min-height": "200px" },
                      model: {
                        value: _vm.produit.commentairesLigne,
                        callback: function($$v) {
                          _vm.$set(_vm.produit, "commentairesLigne", $$v)
                        },
                        expression: "produit.commentairesLigne"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _c(
            "div",
            {
              class:
                _vm.selected && _vm.produit.tarifs.length !== 0
                  ? "col-12 col-lg-9 col-xl-9 position-absolue"
                  : "col-12 col-lg-9 col-xl-9"
            },
            [
              _c("div", [
                _vm.selected
                  ? _c(
                      "div",
                      [
                        _c(
                          "b-card",
                          [
                            _c(
                              "b-tabs",
                              {
                                model: {
                                  value: _vm.currentTabIndex,
                                  callback: function($$v) {
                                    _vm.currentTabIndex = $$v
                                  },
                                  expression: "currentTabIndex"
                                }
                              },
                              [
                                _vm._l(_vm.produit.tarifs, function(tarif, i) {
                                  return _c(
                                    "b-tab",
                                    {
                                      key: i,
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "title",
                                            fn: function() {
                                              return [
                                                _vm.erreurAllergenes(tarif) ||
                                                _vm.erreurRepartitions(tarif)
                                                  ? _c("i", {
                                                      directives: [
                                                        {
                                                          name: "tooltip",
                                                          rawName: "v-tooltip",
                                                          value: {
                                                            content:
                                                              "Erreurs de tarif",
                                                            placement: "bottom",
                                                            classes: [
                                                              "tooltip-light"
                                                            ]
                                                          },
                                                          expression:
                                                            "{content: 'Erreurs de tarif', placement: 'bottom', classes: ['tooltip-light']}"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "fa fa-exclamation-triangle",
                                                      staticStyle: {
                                                        color:
                                                          "#D30943!important"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm.fournisseurEstLocal(
                                                  tarif.fournisseurId
                                                )
                                                  ? _c("i", {
                                                      staticClass:
                                                        "icone-fournisseurLocal mr-2"
                                                    })
                                                  : _vm._e(),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.nomFournisseur(
                                                        tarif.fournisseurId
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _c("div", { staticClass: "card" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "card-header no-radius flex-center-space-between"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "flex-start" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(tarif.designation) +
                                                    " "
                                                ),
                                                _vm.produit.sousCategorie ||
                                                _vm.produit.categorie
                                                  ? _c("span", [_vm._v(" - ")])
                                                  : _vm._e(),
                                                _vm.produit.sousCategorie
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "categorie-container color-administration-primary"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.produit
                                                              .sousCategorie
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v("  "),
                                                _vm.produit.categorie
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "categorie-container color-administration-primary"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.produit
                                                              .categorie
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.profilIsAdmin
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-primary",
                                                        staticStyle: {
                                                          "margin-left": "10px"
                                                        },
                                                        attrs: {
                                                          type: "button",
                                                          title:
                                                            "Copier l'ID interne"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.copierIdInterne(
                                                              tarif
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "far fa-copy"
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "flex-end" },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "tooltip",
                                                        rawName: "v-tooltip",
                                                        value: {
                                                          content:
                                                            "Enregistrer les modifications",
                                                          placement: "top"
                                                        },
                                                        expression:
                                                          "{ content: 'Enregistrer les modifications', placement: 'top' }"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "btn btn-success push-right-1rem",
                                                    style:
                                                      !_vm.enregistrementEnCours &&
                                                      _vm.tarifEstModifie(
                                                        tarif.tarifId
                                                      )
                                                        ? "border: 1px solid red"
                                                        : "",
                                                    attrs: {
                                                      type: "submit",
                                                      size: "sm",
                                                      disabled:
                                                        _vm.enregistrementEnCours ||
                                                        !_vm.tarifEstModifie(
                                                          tarif.tarifId
                                                        ) ||
                                                        !_vm.tarifEstValide(
                                                          tarif
                                                        )
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.preventDefault()
                                                        return _vm.sauveTarifFournisseur(
                                                          tarif,
                                                          _vm.produit
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fas fa-save",
                                                      class: {
                                                        "fa-spin ":
                                                          _vm.enregistrementEnCours
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _c(
                                                  "b-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "tooltip",
                                                        rawName: "v-tooltip",
                                                        value: {
                                                          content:
                                                            "Supprimer l'article",
                                                          placement: "top"
                                                        },
                                                        expression:
                                                          "{ content: 'Supprimer l\\'article', placement: 'top' }"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "btn btn-danger",
                                                    class: {
                                                      "fa-spin ":
                                                        _vm.desactivationTarifEnCours
                                                    },
                                                    attrs: {
                                                      type: "submit",
                                                      size: "sm",
                                                      disabled:
                                                        _vm.desactivationTarifEnCours ||
                                                        !tarif.tarifId
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.preventDefault()
                                                        return _vm.desactiveTarifHM(
                                                          tarif
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v(" × ")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "container-fluid" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "card-content" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "card-body" },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "row" },
                                                      [
                                                        _vm.erreur
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  height: "48px"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "alert alert-warning",
                                                                    attrs: {
                                                                      role:
                                                                        "alert"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.erreur
                                                                        ) +
                                                                        " "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      { staticClass: "row" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12",
                                                            staticStyle: {
                                                              "padding-left":
                                                                "0"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "designation-container"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "designation-input-container"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle: {
                                                                          width:
                                                                            "70%"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "input",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "model",
                                                                                rawName:
                                                                                  "v-model.trim",
                                                                                value:
                                                                                  tarif.designation,
                                                                                expression:
                                                                                  "tarif.designation",
                                                                                modifiers: {
                                                                                  trim: true
                                                                                }
                                                                              },
                                                                              {
                                                                                name:
                                                                                  "tooltip",
                                                                                rawName:
                                                                                  "v-tooltip",
                                                                                value: {
                                                                                  content:
                                                                                    "Désignation chez le fournisseur",
                                                                                  placement:
                                                                                    "top"
                                                                                },
                                                                                expression:
                                                                                  "{ content: 'Désignation chez le fournisseur', placement: 'top' }"
                                                                              }
                                                                            ],
                                                                            staticStyle: {
                                                                              width:
                                                                                "70%"
                                                                            },
                                                                            attrs: {
                                                                              type:
                                                                                "text",
                                                                              placeholder:
                                                                                "Désignation"
                                                                            },
                                                                            domProps: {
                                                                              value:
                                                                                tarif.designation
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  $event
                                                                                    .target
                                                                                    .composing
                                                                                ) {
                                                                                  return
                                                                                }
                                                                                _vm.$set(
                                                                                  tarif,
                                                                                  "designation",
                                                                                  $event.target.value.trim()
                                                                                )
                                                                              },
                                                                              blur: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.$forceUpdate()
                                                                              }
                                                                            }
                                                                          }
                                                                        ),
                                                                        !tarif.designation
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "error"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "Ce champ est requis"
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e()
                                                                      ]
                                                                    ),
                                                                    tarif.marque &&
                                                                    !_vm.surGreAGre
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "tooltip",
                                                                                rawName:
                                                                                  "v-tooltip",
                                                                                value: {
                                                                                  content:
                                                                                    "Marque produit",
                                                                                  placement:
                                                                                    "top"
                                                                                },
                                                                                expression:
                                                                                  "{ content: 'Marque produit', placement: 'top' }"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "label-input",
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.copyToClipboard(
                                                                                  tarif.marque
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                tarif.marque
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm.surGreAGre
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "tooltip",
                                                                                rawName:
                                                                                  "v-tooltip",
                                                                                value: {
                                                                                  content:
                                                                                    "Marque produit",
                                                                                  placement:
                                                                                    "top"
                                                                                },
                                                                                expression:
                                                                                  "{ content: 'Marque produit', placement: 'top' }"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "label-input"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "input",
                                                                              {
                                                                                directives: [
                                                                                  {
                                                                                    name:
                                                                                      "model",
                                                                                    rawName:
                                                                                      "v-model.trim",
                                                                                    value:
                                                                                      tarif.marque,
                                                                                    expression:
                                                                                      "tarif.marque",
                                                                                    modifiers: {
                                                                                      trim: true
                                                                                    }
                                                                                  }
                                                                                ],
                                                                                staticStyle: {
                                                                                  width:
                                                                                    "80%"
                                                                                },
                                                                                attrs: {
                                                                                  type:
                                                                                    "text",
                                                                                  placeholder:
                                                                                    "Marque"
                                                                                },
                                                                                domProps: {
                                                                                  value:
                                                                                    tarif.marque
                                                                                },
                                                                                on: {
                                                                                  input: function(
                                                                                    $event
                                                                                  ) {
                                                                                    if (
                                                                                      $event
                                                                                        .target
                                                                                        .composing
                                                                                    ) {
                                                                                      return
                                                                                    }
                                                                                    _vm.$set(
                                                                                      tarif,
                                                                                      "marque",
                                                                                      $event.target.value.trim()
                                                                                    )
                                                                                  },
                                                                                  blur: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.$forceUpdate()
                                                                                  }
                                                                                }
                                                                              }
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    tarif.reference &&
                                                                    !_vm.surGreAGre
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "tooltip",
                                                                                rawName:
                                                                                  "v-tooltip",
                                                                                value: {
                                                                                  content:
                                                                                    "Référence produit",
                                                                                  placement:
                                                                                    "top"
                                                                                },
                                                                                expression:
                                                                                  "{ content: 'Référence produit', placement: 'top' }"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "label-input",
                                                                            staticStyle: {
                                                                              "font-weight":
                                                                                "bolder"
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.copyToClipboard(
                                                                                  tarif.reference
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                tarif.reference
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm.surGreAGre
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "tooltip",
                                                                                rawName:
                                                                                  "v-tooltip",
                                                                                value: {
                                                                                  content:
                                                                                    "Référence produit",
                                                                                  placement:
                                                                                    "top"
                                                                                },
                                                                                expression:
                                                                                  "{ content: 'Référence produit', placement: 'top' }"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "label-input"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "input",
                                                                              {
                                                                                directives: [
                                                                                  {
                                                                                    name:
                                                                                      "model",
                                                                                    rawName:
                                                                                      "v-model.trim",
                                                                                    value:
                                                                                      tarif.reference,
                                                                                    expression:
                                                                                      "tarif.reference",
                                                                                    modifiers: {
                                                                                      trim: true
                                                                                    }
                                                                                  }
                                                                                ],
                                                                                staticStyle: {
                                                                                  width:
                                                                                    "70%"
                                                                                },
                                                                                attrs: {
                                                                                  type:
                                                                                    "text",
                                                                                  placeholder:
                                                                                    "Référence"
                                                                                },
                                                                                domProps: {
                                                                                  value:
                                                                                    tarif.reference
                                                                                },
                                                                                on: {
                                                                                  input: function(
                                                                                    $event
                                                                                  ) {
                                                                                    if (
                                                                                      $event
                                                                                        .target
                                                                                        .composing
                                                                                    ) {
                                                                                      return
                                                                                    }
                                                                                    _vm.$set(
                                                                                      tarif,
                                                                                      "reference",
                                                                                      $event.target.value.trim()
                                                                                    )
                                                                                  },
                                                                                  blur: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.$forceUpdate()
                                                                                  }
                                                                                }
                                                                              }
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    !_vm.surGreAGre
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "switch-container switch-administration"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "ToggleButton",
                                                                              {
                                                                                staticClass:
                                                                                  "mx-2 switch-plan-de-menu",
                                                                                attrs: {
                                                                                  labels: {
                                                                                    checked:
                                                                                      "FT valide",
                                                                                    unchecked:
                                                                                      "FT invalide"
                                                                                  },
                                                                                  width: 150,
                                                                                  title:
                                                                                    "Cette fiche technique est elle valide ?"
                                                                                },
                                                                                on: {
                                                                                  change: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.setTarifEstOk(
                                                                                      $event,
                                                                                      tarif
                                                                                    )
                                                                                  }
                                                                                },
                                                                                model: {
                                                                                  value:
                                                                                    tarif.ftEstOk,
                                                                                  callback: function(
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      tarif,
                                                                                      "ftEstOk",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                  expression:
                                                                                    "tarif.ftEstOk"
                                                                                }
                                                                              }
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm.surGreAGre
                                                                      ? _c(
                                                                          "div",
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "input-box flex-end"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "label-input"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "P.U"
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "InputNumber",
                                                                                  {
                                                                                    directives: [
                                                                                      {
                                                                                        name:
                                                                                          "tooltip",
                                                                                        rawName:
                                                                                          "v-tooltip",
                                                                                        value: {
                                                                                          content:
                                                                                            "Prix Unitaire (selon PCB)",
                                                                                          placement:
                                                                                            "top"
                                                                                        },
                                                                                        expression:
                                                                                          "{ content: 'Prix Unitaire (selon PCB)', placement: 'top' }"
                                                                                      }
                                                                                    ],
                                                                                    attrs: {
                                                                                      id:
                                                                                        "pu-" +
                                                                                        tarif.tarifId,
                                                                                      typeFiltre:
                                                                                        "montant"
                                                                                    },
                                                                                    model: {
                                                                                      value:
                                                                                        tarif.pu,
                                                                                      callback: function(
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          tarif,
                                                                                          "pu",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                      expression:
                                                                                        "tarif.pu"
                                                                                    }
                                                                                  }
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "input-group-append"
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "input-group-text"
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "€"
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ],
                                                                              1
                                                                            ),
                                                                            !tarif.pu
                                                                              ? _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "error"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Ce champ est requis"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e()
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "inline-inputs push-top-1rem"
                                                              },
                                                              [
                                                                _c("div", [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "flex-start"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "label-input"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "PCB :"
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm.surGreAGre
                                                                        ? _c(
                                                                            "InputNumber",
                                                                            {
                                                                              staticStyle: {
                                                                                margin:
                                                                                  "2px",
                                                                                width:
                                                                                  "50px"
                                                                              },
                                                                              attrs: {
                                                                                id:
                                                                                  "pcb-" +
                                                                                  tarif.tarifId,
                                                                                typeFiltre:
                                                                                  "quantite"
                                                                              },
                                                                              model: {
                                                                                value:
                                                                                  tarif.pcb,
                                                                                callback: function(
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    tarif,
                                                                                    "pcb",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                                expression:
                                                                                  "tarif.pcb"
                                                                              }
                                                                            }
                                                                          )
                                                                        : _c(
                                                                            "div",
                                                                            {
                                                                              staticStyle: {
                                                                                margin:
                                                                                  "2px"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  tarif.pcb
                                                                                ) +
                                                                                  " "
                                                                              )
                                                                            ]
                                                                          ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "input-group-append"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "input-group-text"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .produit
                                                                                    .uc
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  !tarif.pcb
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "error"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Ce champ est requis"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]),
                                                                _c("div", [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "flex-end"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "input-group-prepend"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "input-group-text"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "1 " +
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .produit
                                                                                      .uc
                                                                                  ) +
                                                                                  " ="
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "InputNumber",
                                                                        {
                                                                          class:
                                                                            "saisieRepartition",
                                                                          attrs: {
                                                                            id:
                                                                              "pce-" +
                                                                              tarif.tarifId,
                                                                            typeFiltre:
                                                                              "quantite"
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              tarif.parPCE,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                tarif,
                                                                                "parPCE",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "tarif.parPCE"
                                                                          }
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "input-group-append"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "input-group-text"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "PCE, "
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "InputNumber",
                                                                        {
                                                                          class:
                                                                            "saisieRepartition",
                                                                          attrs: {
                                                                            id:
                                                                              "kg-" +
                                                                              tarif.tarifId,
                                                                            typeFiltre:
                                                                              "quantite"
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              tarif.parKg,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                tarif,
                                                                                "parKg",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "tarif.parKg"
                                                                          }
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "input-group-append"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "input-group-text"
                                                                            },
                                                                            [
                                                                              _vm.estInvalidePour(
                                                                                "KG",
                                                                                tarif.parKg
                                                                              )
                                                                                ? _c(
                                                                                    "i",
                                                                                    {
                                                                                      directives: [
                                                                                        {
                                                                                          name:
                                                                                            "b-tooltip",
                                                                                          rawName:
                                                                                            "v-b-tooltip.hover",
                                                                                          modifiers: {
                                                                                            hover: true
                                                                                          }
                                                                                        }
                                                                                      ],
                                                                                      staticClass:
                                                                                        "error fas fa-exclamation-circle",
                                                                                      attrs: {
                                                                                        title:
                                                                                          "Cette valeur devrait être 1"
                                                                                      }
                                                                                    }
                                                                                  )
                                                                                : _vm._e(),
                                                                              _vm._v(
                                                                                "KG, "
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "InputNumber",
                                                                        {
                                                                          class:
                                                                            "saisieRepartition",
                                                                          attrs: {
                                                                            id:
                                                                              "l-" +
                                                                              tarif.tarifId,
                                                                            typeFiltre:
                                                                              "quantite"
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              tarif.parL,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                tarif,
                                                                                "parL",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "tarif.parL"
                                                                          }
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "input-group-append"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "input-group-text"
                                                                            },
                                                                            [
                                                                              _vm.estInvalidePour(
                                                                                "L",
                                                                                tarif.parL
                                                                              )
                                                                                ? _c(
                                                                                    "i",
                                                                                    {
                                                                                      directives: [
                                                                                        {
                                                                                          name:
                                                                                            "b-tooltip",
                                                                                          rawName:
                                                                                            "v-b-tooltip.hover",
                                                                                          modifiers: {
                                                                                            hover: true
                                                                                          }
                                                                                        }
                                                                                      ],
                                                                                      staticClass:
                                                                                        "error fas fa-exclamation-circle",
                                                                                      attrs: {
                                                                                        title:
                                                                                          "Cette valeur devrait être 1"
                                                                                      }
                                                                                    }
                                                                                  )
                                                                                : _vm._e(),
                                                                              _vm._v(
                                                                                "L."
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "b-button",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "tooltip",
                                                                              rawName:
                                                                                "v-tooltip",
                                                                              value: {
                                                                                content:
                                                                                  "Réinitialiser les valeurs",
                                                                                placement:
                                                                                  "top"
                                                                              },
                                                                              expression:
                                                                                "{ content: 'Réinitialiser les valeurs', placement: 'top' }"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "btn-primary",
                                                                          staticStyle: {
                                                                            "margin-left":
                                                                              "5px"
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.viderLesValeursEn(
                                                                                tarif.tarifId
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "RAZ"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  !tarif.parPCE &&
                                                                  !tarif.parKg &&
                                                                  !tarif.parL
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "error"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Attention, les répartitions doivent être renseignées pour être prises en compte dans les calculs automatiques"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "flex-end",
                                                                      staticStyle: {
                                                                        "margin-top":
                                                                          "3px"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c("p", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.phraseConversion(
                                                                              tarif,
                                                                              _vm
                                                                                .produit
                                                                                .uc,
                                                                              false,
                                                                              false
                                                                            )
                                                                          )
                                                                        )
                                                                      ])
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "flex-end"
                                                                    },
                                                                    [
                                                                      _c("p", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.phraseConversion(
                                                                              tarif,
                                                                              _vm
                                                                                .produit
                                                                                .uc,
                                                                              true,
                                                                              false
                                                                            )
                                                                          )
                                                                        )
                                                                      ])
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "flex-end"
                                                                    },
                                                                    [
                                                                      _c("p", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.phraseConversion(
                                                                              tarif,
                                                                              _vm
                                                                                .produit
                                                                                .uc,
                                                                              true,
                                                                              true
                                                                            )
                                                                          )
                                                                        )
                                                                      ])
                                                                    ]
                                                                  )
                                                                ])
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "inline-inputs flex-center-space-between"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  [
                                                                    _c(
                                                                      "MultiSelect",
                                                                      {
                                                                        staticClass:
                                                                          "push-right-2rem",
                                                                        staticStyle: {
                                                                          "min-width":
                                                                            "500px"
                                                                        },
                                                                        attrs: {
                                                                          disabled:
                                                                            tarif.aucunAllergene,
                                                                          value:
                                                                            tarif.allergenesMajeurs,
                                                                          items:
                                                                            _vm.allergenes,
                                                                          itemText:
                                                                            "valeur",
                                                                          itemValue:
                                                                            "id",
                                                                          placeholder:
                                                                            "Allergènes...",
                                                                          emptyText:
                                                                            "Tous les allergènes ont été ajoutés"
                                                                        },
                                                                        on: {
                                                                          change: function(
                                                                            $event
                                                                          ) {
                                                                            tarif.allergenesMajeurs = $event
                                                                          }
                                                                        }
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "show",
                                                                            rawName:
                                                                              "v-show",
                                                                            value:
                                                                              !tarif.aucunAllergene &&
                                                                              (!tarif.allergenesMajeurs ||
                                                                                tarif
                                                                                  .allergenesMajeurs
                                                                                  .length ===
                                                                                  0),
                                                                            expression:
                                                                              "!tarif.aucunAllergene && (!tarif.allergenesMajeurs || tarif.allergenesMajeurs.length === 0)"
                                                                          }
                                                                        ],
                                                                        staticClass:
                                                                          "error"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Allergènes non renseignés"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "form-group"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "label",
                                                                      [
                                                                        _c(
                                                                          "input",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  tarif.aucunAllergene,
                                                                                expression:
                                                                                  "tarif.aucunAllergene"
                                                                              }
                                                                            ],
                                                                            attrs: {
                                                                              type:
                                                                                "checkbox",
                                                                              id:
                                                                                "chkAcunAllergene" +
                                                                                tarif.tarifId,
                                                                              disabled:
                                                                                tarif.allergenesMajeurs &&
                                                                                tarif
                                                                                  .allergenesMajeurs
                                                                                  .length !==
                                                                                  0
                                                                            },
                                                                            domProps: {
                                                                              checked: Array.isArray(
                                                                                tarif.aucunAllergene
                                                                              )
                                                                                ? _vm._i(
                                                                                    tarif.aucunAllergene,
                                                                                    null
                                                                                  ) >
                                                                                  -1
                                                                                : tarif.aucunAllergene
                                                                            },
                                                                            on: {
                                                                              change: function(
                                                                                $event
                                                                              ) {
                                                                                var $$a =
                                                                                    tarif.aucunAllergene,
                                                                                  $$el =
                                                                                    $event.target,
                                                                                  $$c = $$el.checked
                                                                                    ? true
                                                                                    : false
                                                                                if (
                                                                                  Array.isArray(
                                                                                    $$a
                                                                                  )
                                                                                ) {
                                                                                  var $$v = null,
                                                                                    $$i = _vm._i(
                                                                                      $$a,
                                                                                      $$v
                                                                                    )
                                                                                  if (
                                                                                    $$el.checked
                                                                                  ) {
                                                                                    $$i <
                                                                                      0 &&
                                                                                      _vm.$set(
                                                                                        tarif,
                                                                                        "aucunAllergene",
                                                                                        $$a.concat(
                                                                                          [
                                                                                            $$v
                                                                                          ]
                                                                                        )
                                                                                      )
                                                                                  } else {
                                                                                    $$i >
                                                                                      -1 &&
                                                                                      _vm.$set(
                                                                                        tarif,
                                                                                        "aucunAllergene",
                                                                                        $$a
                                                                                          .slice(
                                                                                            0,
                                                                                            $$i
                                                                                          )
                                                                                          .concat(
                                                                                            $$a.slice(
                                                                                              $$i +
                                                                                                1
                                                                                            )
                                                                                          )
                                                                                      )
                                                                                  }
                                                                                } else {
                                                                                  _vm.$set(
                                                                                    tarif,
                                                                                    "aucunAllergene",
                                                                                    $$c
                                                                                  )
                                                                                }
                                                                              }
                                                                            }
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " Aucun allergène "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "input-box",
                                                                    staticStyle: {
                                                                      width:
                                                                        "30%"
                                                                    }
                                                                  },
                                                                  [
                                                                    !_vm.surGreAGre
                                                                      ? _c(
                                                                          "input",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  tarif.codeEan,
                                                                                expression:
                                                                                  "tarif.codeEan"
                                                                              }
                                                                            ],
                                                                            staticStyle: {
                                                                              width:
                                                                                "100%"
                                                                            },
                                                                            attrs: {
                                                                              type:
                                                                                "text",
                                                                              placeholder:
                                                                                "Code EAN",
                                                                              title:
                                                                                "Code EAN"
                                                                            },
                                                                            domProps: {
                                                                              value:
                                                                                tarif.codeEan
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  $event
                                                                                    .target
                                                                                    .composing
                                                                                ) {
                                                                                  return
                                                                                }
                                                                                _vm.$set(
                                                                                  tarif,
                                                                                  "codeEan",
                                                                                  $event
                                                                                    .target
                                                                                    .value
                                                                                )
                                                                              }
                                                                            }
                                                                          }
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        !_vm.surGreAGre
                                          ? _c(
                                              "div",
                                              { staticClass: "card-content" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "card-body card-pdf"
                                                  },
                                                  [
                                                    tarif.ftLien
                                                      ? _c("span", [
                                                          tarif.ftLien
                                                            .toLowerCase()
                                                            .startsWith("https")
                                                            ? _c("div", [
                                                                _c(
                                                                  "object",
                                                                  {
                                                                    attrs: {
                                                                      title:
                                                                        "Si le message d'erreur commence par BlobNotFound, la fiche technique est manquant sur le Cloud Agap.",
                                                                      data:
                                                                        tarif.ftLien,
                                                                      width:
                                                                        "100%",
                                                                      height:
                                                                        "1300px",
                                                                      type:
                                                                        "application/pdf"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("div", [
                                                                      _c("p", [
                                                                        _vm._v(
                                                                          "Un problème a été rencontré lors de l'ouverture de la fiche technique."
                                                                        )
                                                                      ]),
                                                                      _c("p", [
                                                                        _vm._v(
                                                                          "Vous pouvez cliquer sur le lien suivant pour la télécharger :"
                                                                        )
                                                                      ]),
                                                                      _c(
                                                                        "a",
                                                                        {
                                                                          attrs: {
                                                                            href:
                                                                              tarif.ftLien,
                                                                            target:
                                                                              "_blank",
                                                                            rel:
                                                                              "noopener noreferrer"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              tarif.ftLien
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ])
                                                                  ]
                                                                )
                                                              ])
                                                            : _c("div", [
                                                                _c("p", [
                                                                  _vm._v(
                                                                    "Pour des raisons dépendantes du site du fournisseur, nous ne pouvons afficher directement la fiche technique."
                                                                  )
                                                                ]),
                                                                _c("p", [
                                                                  _vm._v(
                                                                    "Vous pouvez cliquer sur le lien suivant pour la télécharger :"
                                                                  )
                                                                ]),
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    attrs: {
                                                                      href:
                                                                        tarif.ftLien,
                                                                      target:
                                                                        "_blank",
                                                                      rel:
                                                                        "noopener noreferrer"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        tarif.ftLien
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ])
                                                        ])
                                                      : _c("span", [
                                                          _vm._v(
                                                            "Aucune fiche technique"
                                                          )
                                                        ])
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    ]
                                  )
                                }),
                                _vm.surGreAGre && _vm.optionsFournisseurs.length
                                  ? _c("b-tab", {
                                      key: _vm.produit.tarifs.length,
                                      attrs: {
                                        title: "+ FOURNISSEUR",
                                        "title-link-class": [
                                          "bg-tab-new",
                                          "vertAgap"
                                        ]
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.afficherAjoutFournisseur()
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("datalist", { attrs: { id: "texteUC" } }, [
      _c("option", { attrs: { value: "Kg" } }),
      _c("option", { attrs: { value: "Litre" } }),
      _c("option", { attrs: { value: "Carton" } }),
      _c("option", { attrs: { value: "Unité" } }),
      _c("option", { attrs: { value: "Pièce" } }),
      _c("option", { attrs: { value: "Seau" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }